import * as Joi from 'joi';

export const carModelCreateUpdateSchema = Joi.object({
  name: Joi.string().required().max(255),
  car_brand_id: Joi.number().required(),
});
